(function() {
  'use strict';

  angular.module('ringbaPortal').component('checkboxTagsTree', {
    bindings: {
      availableTags: '<',
      selectedTags: '<',
      showSelected: '<'
    },
    controller: CheckBoxTagsTreeController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/checkbox-tags-tree/checkbox-tags-tree.view.html'
  });

  function CheckBoxTagsTreeController($scope) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;

    vm.buyerAccessToTags = false;
    vm.showTags = [];
    vm.searchSelectedTags = '';
    vm.searchTags = '';
    vm.displayTagType = displayTagType;
    vm.displayTag = displayTag;
    vm.tagTypeCheckClass = tagTypeCheckClass;
    vm.changeTypeStatus = changeTypeStatus;
    vm.changeTagStatus = changeTagStatus;
    vm.toggleTag = toggleTag;
    vm.removeOption = removeOption;
    vm.$onChanges = onChanges;

    function onInit() {
      _getTagsWithCategory();
      _loadSelectedTags();
    }

    function onChanges() {
      _loadSelectedTags();
    }

    $scope.filterTagChecked = function(elm) {
      return elm.checked && elm.tagName;
    };

    function toggleTag(tagType) {
      vm.showTags[tagType] = !vm.showTags[tagType];
    }

    function changeTypeStatus(changedTag) {
      _.forEach(vm.tagTypes, function (tag) {
        if (tag.tagType == changedTag.tagType) {
          if (tag.tagName && tag.tagName.toLowerCase().includes(vm.searchTags.toLowerCase())) {
            tag.checked = changedTag.checked;
          }
        }
      });
    }

    function changeTagStatus(checkedTag) {
      const allTagsFromTypeAreChecked = _.some(_.filter(vm.tagTypes, function (tag) {
        return tag.tagName && tag.tagType == checkedTag.tagType;
      }), { 'checked': true });

      _.forEach(vm.tagTypes, function (tag) {
        if (tag.tagType == checkedTag.tagType && !tag.tagName) {
          if (tag.checked != allTagsFromTypeAreChecked) {
            tag.checked = allTagsFromTypeAreChecked;
          }
        }
      });
    }

    function removeOption(removeTag) {
      _.forEach(vm.tagTypes, function (tag) {
        if (tag.tagType == removeTag.tagType && tag.tagName == removeTag.tagName) {
          tag.checked = false;
          changeTagStatus(tag);
        }
      });
    }

    function displayTagType(tag, searchTags) {
      searchTags = searchTags.toLowerCase();
      return !tag.tagName && (tag.tagType.toLowerCase().includes(searchTags) || _anyTagInsideType(tag, searchTags));
    }

    function displayTag(tag, searchTags) {
      searchTags = searchTags.toLowerCase();
      return !!tag.tagName
        && (tag.tagName.toLowerCase().includes(searchTags) // Tag name includes text
        || tag.tagType.toLowerCase().includes(searchTags)) // Tag name includes text
        && (vm.showTags[tag.tagType] || searchTags.length > 3); // The collapse is shown or the search filter length is greater than 3 (arbitrary value)
    }

    function tagTypeCheckClass(tagType) {
      let oneChecked = false;
      let typeClass = 'ag-checked';
      _.forEach(vm.tagTypes, function (tag) {
        if (tag.tagType != tagType || !tag.tagName)
          return;
        if (!tag.checked) {
          typeClass = '';
        } else {
          oneChecked = true;
        }
      });

      return oneChecked && typeClass == '' ? 'ag-indeterminate' : typeClass;
    }

    function _anyTagInsideType(tag, searchTags) {
      return _.some(vm.availableTags, function (t) {
        return t.tagType == tag.tagType && t.tagName.toLowerCase().includes(searchTags);
      });
    }

    function _loadSelectedTags() {
      const selectedTags = _.map(vm.selectedTags, function (t) { return t.split(':'); });
      _.forEach(vm.tagTypes, function (tag) {
        tag.checked = _.some(selectedTags, { 0: tag.tagType, 1: tag.tagName});
      });
    }

    function _getTagsWithCategory() {
      const tags = _.sortBy(vm.availableTags, ['tagType']);
      if (tags && tags.length > 0) {
        let tagType = tags[tags.length - 1].tagType;
        for (let i = tags.length - 1; i >= 0; i--) {
          if (tags[i].tagType != tagType) {
            tags.splice(i + 1, 0, {
              tagType: tagType
            });
            tagType = tags[i].tagType;
          }
          if (i == 0) {
            tags.splice(0, 0, {
              tagType: tagType
            });
          }
          vm.showTags[tagType] = false;
        }
      }
      vm.tagTypes =  tags;
    }
  }
})();
